var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useMemo } from "react";
import TimePicker from "rc-time-picker";
import tinycolor from "tinycolor2";
import "rc-time-picker/assets/index.css";
import moment from "moment";
import styled from "styled-components";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n\n  .custom-timepicker {\n    width: 100%;\n    display: flex;\n    align-items: center;\n\n    input {\n      width: 100%;\n      border: 1px solid ", ";\n      border-radius: ", ";\n      padding: 12px 12px;\n      line-height: 1em;\n      font-size: 1.4rem;\n      height: 40px;\n      outline: none;\n      color: ", ";\n\n      &:focus {\n        background-color: ", ";\n      }\n    }\n  }\n"], ["\n  display: inline-block;\n\n  .custom-timepicker {\n    width: 100%;\n    display: flex;\n    align-items: center;\n\n    input {\n      width: 100%;\n      border: 1px solid ", ";\n      border-radius: ", ";\n      padding: 12px 12px;\n      line-height: 1em;\n      font-size: 1.4rem;\n      height: 40px;\n      outline: none;\n      color: ", ";\n\n      &:focus {\n        background-color: ",
    ";\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.main.borderColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.main.color;
}, function (_a) {
    var theme = _a.theme;
    return tinycolor(theme.gwThemed.inputs.main.color).lighten(45).toString();
});
export var InputTime = function (_a) {
    var selected = _a.selected, onChange = _a.onChange;
    var value = useMemo(function () { return moment(selected); }, [selected]);
    var handleTimeChange = useCallback(function (newVal) {
        onChange(newVal.toDate());
    }, [onChange]);
    return (React.createElement(Container, null,
        React.createElement(TimePicker, { value: value, onChange: handleTimeChange, showSecond: false, className: "custom-timepicker", allowEmpty: false, use12Hours: true })));
};
var templateObject_1;
//# sourceMappingURL=InputTime.js.map